import { useAccordionItem } from "@website/ui/accordion/accordion.hook";
import styles from "@website/ui/accordion/accordion.module.scss";
import { AccordionPropertiesType } from "@website/ui/accordion/accordion.types";
import { Button } from "@website/ui/button";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Accordion: FC<AccordionPropertiesType> = (properties) => {
  const {
    buttonText,
    buttonProperties,
    contentWrapperProperties,
    detailsProperties,
    summeryProperties
  } = useAccordionItem(properties);
  const {
    content,
    disabled,
    title,
    subtitle,
    variant,
    scroll,
    StartIcon,
    titleClassname,
    contentWrapperClassname,
    noOverflowHidden,
    className
  } = properties;

  return (
    <details
      itemProp="mainEntity"
      itemScope
      itemType="https://schema.org/Question"
      {...detailsProperties}
      className={`${styles["details"]} ${
        styles[variant || "outline"]
      } ${className}`}
    >
      <summary
        {...summeryProperties}
        className={`${styles["summery"]} ${disabled ? styles["disabled"] : ""}`}
      >
        <h3
          className={`${styles["title-wrapper"]} ${titleClassname}`}
          itemProp="name"
        >
          {StartIcon ? <div className={styles["icon"]}>{StartIcon}</div> : null}
          {title}
        </h3>
        {subtitle ? <span className={styles["subtitle"]}>{subtitle}</span> : ""}
        <Button className={styles["button"]} {...buttonProperties}>
          {buttonText}
        </Button>
      </summary>
      <div
        itemProp="acceptedAnswer"
        itemScope
        itemType="https://schema.org/Answer"
        {...contentWrapperProperties}
        className={`${styles["content-wrapper"]} ${contentWrapperClassname} ${
          noOverflowHidden ? styles["no-overflow"] : ""
        }`}
      >
        <div
          className={`${styles["content"]} ${scroll ? styles[scroll] : ""}`}
          itemProp="text"
        >
          {content}
        </div>
      </div>
    </details>
  );
};

const AccordionMemoized = memo(Accordion, deepCompare);
export { AccordionMemoized as Accordion };
